import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { DeviceStatusLabelComponent } from './device-status-label.component';

@NgModule({
	declarations: [DeviceStatusLabelComponent],
	exports: [DeviceStatusLabelComponent],
	imports: [CommonModule, TranslateModule],
})
export class DeviceStatusLabelModule {}
